import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export function useJobId() {
  const api = useApi()
  const [dataJobId, setData] = useState<SelectOptionType[]>([])
  const [isLoadingJobId, setLoading] = useState(true)

  useEffect(() => {
    api.get("/project/")
    .then((res: SuccessFetch<{
      payload: {
        project_id: string
        project_name: string }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.project_name, value: item.project_id }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { dataJobId, isLoadingJobId }
}